/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 17:02:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-08 09:02:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/GiftPurchase/GiftPurchaseEdit/Summary/index.tsx
 */
import Configuration from '@/src/components/Configuration/Configuration';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SummaryComponent from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/Summary';
import { EProductType } from 'src/pages/StoreVoucher/Detail/Components/ProductsApplyToRadioAndTable';
import { ECondition } from 'src/pages/StoreVoucher/Detail/VoucherSendTo';
import { EMethod } from 'src/pages/StoreVoucher/Detail/VoucherType';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { EShipping, EnumStatus } from 'src/types/common/discount';
import css from './css.module.less';

const Summary = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { data } = props;
  const {
    //total,
    used,
    delivered,

    uuid,
    applyTo,
    currency,
    customerCondition,
    salesChannels,
    usageLimitation,
    voucherMethod,
    voucherType,
    status,
    beginDate = '',
    beginTime = '',
    endDate = '',
    endTime = '',
    customerDatabase,
    voucherNo,
    voucherQuantity,
  } = data || {};
  const { limited, totalQuantity } = voucherQuantity || {};

  const remaining = (totalQuantity || 0) - (used || 0) - (delivered || 0);
  // const {
  //   beginDate = '',
  //   beginTime = '',
  //   endDate = '',
  //   endTime = '',
  // } = activeTime;

  const renderSummaryData = () => {
    const begin = beginDate
      ? moment(beginDate + ' ' + beginTime).format('MM/DD/YYYY HH:mm')
      : '';
    const end = endDate
      ? moment(endDate + ' ' + endTime).format('MM/DD/YYYY HH:mm')
      : '';

    const displaySalesChannels = (salesChannels || []).reduce((pre, sc) => {
      const { uuid } = sc;

      return { ...pre, [uuid]: sc };
    }, {});

    const dbLine = customerDatabase
      ? `${getI18n('salesChannelVoucher.summary.customerdatabaseis')} ${
          get(customerDatabase, 'name') || ''
        }`
      : '';

    const currencyLine = currency
      ? `${getI18n('salesChannelVoucher.summary.currencyis')} ${currency || ''}`
      : '';
    const salesChannelLine =
      (salesChannels || []).length > 0
        ? `${getI18n(
            'salesChannelVoucher.summary.salesChannelsare',
          )} ${salesChannels.map((i) => i.name).join(' , ')}`
        : '';

    const {
      percentage,
      deduction,
      shippingDiscountType,
      fixedAmount,
      salesChannelGifts,
    } = voucherMethod || {};
    const freeItemsTip = (salesChannelGifts || []).map((i, index) => {
      const { quantities, salesChannelUuid } = i;
      const name = get(
        displaySalesChannels[salesChannelUuid],
        'name',
        `${getI18n('general.sider.salesChannel')} ${index + 1}`,
      );
      let count = 0;
      (quantities || []).forEach((gift) => {
        const { children } = gift;
        if (children) {
          count = count + children.length;
        } else {
          count = count + 1;
        }
      });
      return replaceI18nVariables(
        getI18n('salesChannelVoucher.summary.hasItems'),
        name,
        count,
      );
    });

    const { combinedWithVoucher, combinedWithPromotion } =
      usageLimitation || {};

    const { flashSaleExcluded = '', conditionType = '' } = applyTo || {};
    const { conditionType: customerConditionType } = customerCondition || {};

    const discountValueApplies = {
      [EProductType.All]: getI18n(
        'salesChannelDirectDiscount.discountValuebuyOne.allProducts',
      ),
      [EProductType.Specific]: getI18n(
        'salesChannelDirectDiscount.eligibalCondition.specificProducts',
      ),
      [EProductType.NotSpecific]: getI18n(
        'salesChannelDirectDiscount.summary.noSpecific',
      ),
    };

    const discountMethodText = {
      [EMethod.Percentage]: `${percentage || '0'}% ${getI18n(
        'salesChannelDirectDiscount.summary.offappliesto',
      )}  ${discountValueApplies[conditionType]} ${
        flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : ''
      }`,
      [EMethod.Reduction]: `$${deduction || '0'}  ${getI18n(
        'salesChannelDirectDiscount.summary.reductionamountappliesto',
      )} ${
        flashSaleExcluded
          ? getI18n(
              'salesChannelDirectDiscount.summary.excludingflashsaleitems',
            )
          : ''
      }
      .`,
      [EMethod.Shipping]: `${
        shippingDiscountType == EShipping.Free
          ? `${getI18n('salesChannelDirectDiscount.summary.freeshippingto')} `
          : '$' +
            fixedAmount +
            ` ${getI18n(
              'salesChannelDirectDiscount.summary.reductiononshippingrate',
            )}`
      }`,
      [EMethod.Gift]: freeItemsTip.join(' '),
    };

    const customerConditionText = {
      [ECondition.Registered]: getI18n(
        'salesChannelDirectDiscount.summary.forregisteredcustomers',
      ),
      [ECondition.Specific]: getI18n(
        'salesChannelDirectDiscount.summary.forspecificcustomers',
      ),
    };

    // const multiConditions = 'When all of the below conditions are met: ';
    const summaryData = [
      ...(dbLine ? [dbLine] : []),
      ...(currencyLine ? [currencyLine] : []),
      ...(salesChannelLine ? [salesChannelLine] : []),

      ...(begin
        ? [
            `${replaceI18nVariables(
              getI18n('salesChannelDirectDiscount.summary.validfrom'),
              begin,
            )} ${
              end
                ? ` ${getI18n('general.to')} ${end}`
                : ` , ${getI18n(
                    'salesChannelDirectDiscount.summary.noenddate',
                  )}`
            }`,
          ]
        : []),
      ...(voucherType ? [discountMethodText[voucherType]] : []),
      ...(combinedWithVoucher
        ? [getI18n('salesChannelVoucher.summary.voucherCombine')]
        : []),
      ...(combinedWithPromotion
        ? [getI18n('salesChannelVoucher.summary.voucherDiscount')]
        : []),
      ...(customerConditionType
        ? [customerConditionText[customerConditionType]]
        : []),
      !limited
        ? replaceI18nVariables(
            getI18n('salesChannelVoucher.summary.statementUnlimited'),
            delivered,
            used,
          )
        : replaceI18nVariables(
            getI18n('salesChannelVoucher.summary.statement'),
            totalQuantity,
            delivered,
            used,
            remaining,
          ),
    ];

    return summaryData;
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.sectionContainer}
        title={getI18n('general.summary')}>
        <SummaryComponent
          name={voucherNo}
          status={status || EnumStatus.Draft}
          summaryContent={renderSummaryData()}
        />

        <div className={css.configContainer}>
          <Configuration
            configStart={`${getI18n(
              'salesChannelVoucher.summary.configLinkFront',
            )} `}
            configLink={getI18n('salesChannelVoucher.summary.voucherDetails')}
            linkTo={`/storeVoucherEdit/${uuid}`}
            configEnd={getI18n(
              'salesChannelVoucher.summary.tomanagevouchersettings',
            )}
          />
        </div>
      </SectionWrapper>
    </div>
  );
};

export default Summary;
